import { createRouter, createWebHashHistory } from 'vue-router'
import PortalView from '../views/PortalView.vue'
import ReportView from '../views/ReportView.vue'
import AdminView from '../views/AdminView.vue'

const routes = [
  {
    path: '/',
    name: 'portal',
    component: PortalView,
    meta: { title: '信息快速收集（测试）' }
  },
  {
    path: '/gather',
    name: 'report',
    component: ReportView,
    meta: { title: '信息收集' }
  },
  {
    path: '/report',
    redirect: '/gather'
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: { title: '安环后台' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
